
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getAllPosts } from "@/lib/contentQueries";
import { hasSafeContentSegments } from "@/lib/contentRouteSafety";
import { useTina } from "tinacms/dist/react";
import client from "../../../tina/__generated__/client";
import Post from "../../components/blog/BlogPost";
import PostMetadata from "../../components/blog/PostMetadata";
const TopicPostPage = (props) => {
    const { data } = useTina({
        query: props.query,
        variables: props.variables,
        data: props.data,
    });
    if (!data?.post)
        return null;
    return (<>
      <PostMetadata post={data.post} path={props.articlePath}/>
      <Post {...data.post}/>
    </>);
};
export const getStaticPaths = async () => {
    const postConnection = await getAllPosts();
    const paths = [];
    postConnection.data.postConnection.edges.forEach((post) => {
        const [topic, slug] = post.node._sys.breadcrumbs;
        const categorySlug = post.node?.category?.slug;
        if (!topic ||
            !slug ||
            topic === "news" ||
            topic === "openings" ||
            categorySlug === "news") {
            return;
        }
        paths.push({
            params: { topic, slug },
            locale: post.node.locale || "en",
        });
    });
    return {
        paths,
        fallback: process.env.CONTENT_SNAPSHOT_BUILD !== "true" ? "blocking" : false,
    };
};
const getStaticProps = async ({ params }) => {
    const { topic, slug } = params;
    if (!hasSafeContentSegments(topic, slug)) {
        return { notFound: true };
    }
    if (topic === "news") {
        return {
            redirect: { destination: `/news/${slug}`, permanent: true },
        };
    }
    let props;
    try {
        props = await client.queries.post({
            relativePath: `${topic}/${slug}.mdx`,
        });
    }
    catch {
        return { notFound: true };
    }
    if (!props?.data?.post)
        return { notFound: true };
    return { props: { ...props, articlePath: `/${topic}/${slug}` } };
};
export default TopicPostPage;

    async function __Next_Translate__getStaticProps__1a0fc0d53bb__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[topic]/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d53bb__ as getStaticProps }
  